import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatDialog } from '@angular/material';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { merge } from 'hammerjs';
import { DownloadExcelDialogComponent } from 'path-shared/components/dialogs/download-excel-dialog/download-excel-dialog.component';
import { CustomDataSource } from 'path-shared/services/datasource/custom.datasource';
import { FilterService } from 'path-shared/services/filter/filter.service';
import { tap } from 'rxjs/operators';
import { AparellService } from '../../services/aparells-service.service';
import { Builder } from 'path-shared/models/builder';
import { ConjuntAparellsFilter } from '../../models/conjunt-aparells.filter';
import { ConjuntAparells } from '../../models/conjunt-aparells.model';
import { ConjuntsAparellsFilterService } from '../../services/conjunts-aparells.filter.service';
import { ConjuntsAparellsEditorComponent } from '../conjunts-aparells-editor/conjunts-aparells-editor.component';

@Component({
  selector: 'app-aparells-conjunts-table',
  templateUrl: './aparells-conjunts-table.component.html',
  styleUrls: ['./aparells-conjunts-table.component.scss']
})
export class AparellsConjuntsTableComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  
  dataSource: CustomDataSource<ConjuntAparells, ConjuntAparellsFilter>;
  filter: ConjuntAparellsFilter = new ConjuntAparellsFilter('id', 'asc');
  displayedItems = [];
  highlightedRows = [];
  tableLoaded = false;

  @Input() selectButton: boolean;
  @Input()  datas: ConjuntAparells[];
  @Input() updatedFilterData: ConjuntAparellsFilter;
  @Output() notify: EventEmitter<number> = new EventEmitter<number>();
  @Output() itemClicked: EventEmitter<string> = new EventEmitter<string>();
  @Output() itemSelected: EventEmitter<string> = new EventEmitter<string>();

  displayedColumns = ['codi', 'descripcio', 'horaInici', 'horaFi', 'esTransit', 'aparells'];

  constructor(
    private aparellService: AparellService,
    private filterService: FilterService,
    private dialog: MatDialog,
    private i18n: I18n
  ) {
  }

  ngOnInit() {
    this.getConjunts();
  }

  getConjunts() {
    this.sort.disableClear = true;
    this.dataSource = CustomDataSource.create<ConjuntAparells, ConjuntAparellsFilter>(this.paginator, new ConjuntsAparellsFilterService(), 'urlGetConjuntsAparells', 'urlGetConjuntsAparellsCount');
    this.dataSource.subject.subscribe((data) => {
      this.datas = data;
      data.forEach(item => {
        this.displayedItems[item.id] = {
          id: item.id
        };
      });
    });

    this.filter.filterUpdated.subscribe(updated => {
      if (updated) {
        this.load();
        if (!this.selectButton) { this.filterService.saveFilter('conjunt-aparells-filter', this.filter); }
      }
    });

    if (!this.selectButton) { this.filterService.loadFilter('conjunt-aparells-filter', this.filter); }
    this.filter.paginator.init(this.sort, this.paginator);

  }

  ngAfterViewInit() {
    // reset the paginator after sorting
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.filter.paginator.set(this.sort, this.paginator);
      this.filter.updated();
    });

    merge(this.sort.sortChange, this.paginator.page)
    .pipe(tap(() => this.filter.updated()))
    .subscribe();

    this.load();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.updatedFilterData != null) {
      this.update();
    }
  }

  update() {
    if (this.dataSource !== undefined) {
      this.updatedFilterData.paginator.set(this.sort, this.paginator);
      this.dataSource.loadFilter(this.updatedFilterData);
    }
  }

  load() {
    this.filter.paginator.set(this.sort, this.paginator);
    this.dataSource.loadFilter(this.filter);

    this.dataSource.loading$.subscribe(isLoading => this.tableLoaded = !isLoading)
  }

  // onRowClicked(row) {
  //   this.itemClicked.next(row.secureId);
  // }

  generateExcel(): void {
    let filter = this.filter;
    if (this.updatedFilterData != null) {
      filter = this.updatedFilterData;
    }
    this.dialog.open(DownloadExcelDialogComponent, {
        closeOnNavigation: false,
        autoFocus: true,
        data: Builder.newDownloadExcelDialogData (this.aparellService, filter, this.i18n('Conjunts d\'aparells'), this.sort.direction, this.sort.active)
    });
  }

  edit(row: ConjuntAparells) {
    const ref = this.dialog.open(ConjuntsAparellsEditorComponent, {
      width: '70%',
      minHeight: '40%',
      closeOnNavigation: false,
      autoFocus: true,
      data: { conjunt: row, componentDialog: Builder.newComponentDialog(true, false) },
    });

    ref.afterClosed().subscribe(updated => {
      if (updated) { this.load(); }
    });
  }

  showAparells(aparells) {
    return aparells.map(x => x.descripcion).join(String.fromCharCode(10));
  }
}
